import { SVGAttributes } from 'react';

type Props = SVGAttributes<SVGElement>;

export function BrandHandMarkTwoLinesVariant2(props: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="201"
            height="24"
            viewBox="0 0 201 24"
            fill="currentColor"
            {...props}
        >
            <path d="M200.375 20.4207C200.157 21.4381 199.231 21.6017 198.341 21.6198C195.399 21.6744 188.045 19.1852 184.105 18.7128C155.541 15.3696 120.622 17.6226 91.6952 19.2396C70.8672 20.4025 47.9872 23.9818 27.4679 24C25.8336 24 21.3847 23.6184 19.8049 23.3641C18.7335 23.1824 18.4975 22.9462 18.334 21.8924C18.1161 20.5115 18.9333 21.1111 19.8231 21.0202C25.4159 20.4388 30.9362 18.84 36.4383 17.5863L37.782 18.6401L23.6545 22.1831C34.0595 23.037 44.2828 21.1111 54.5788 20.4207C91.7134 17.9315 133.17 14.2795 170.068 16.2599C180.328 16.805 190.369 18.2949 200.375 20.4207Z" />
            <path d="M173.863 2.12434C172.992 3.269 169.777 2.17885 168.797 2.17885C144.555 2.05167 119.532 3.81407 95.2179 5.06774C75.0072 6.10338 54.6514 7.37523 34.5497 9.79173C23.6 11.1181 12.4687 12.7715 1.84591 15.6785L5.96796 18.6038C4.53343 18.6401 2.66308 18.2767 1.42829 17.5499C-2.47583 15.2606 2.64492 14.0796 4.66054 13.4619C10.3624 11.7176 18.0435 10.7365 24.0358 9.86442C66.3456 3.74142 109.218 3.81408 151.746 0.30743C157.884 1.12504 166.582 -0.728232 172.392 0.343748C173.282 0.50727 174.426 1.36122 173.863 2.10616V2.12434Z" />
        </svg>
    );
}
